import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { ClassNameMap } from '@mui/styles';
import { TimeSignalClassification } from 'graphql/types';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(9),
    margin: theme.spacing(0.5, 2)
  },
  label: {
    marginTop: theme.spacing(0.75),
    padding: theme.spacing(0.25, 0.75),
    color: theme.palette.grey[800],
    borderRadius: theme.spacing(0.25)
  },
  [`${TimeSignalClassification.Unclassified}`]: {
    background: theme.palette.notesLabel.inbox
  },
  [`${TimeSignalClassification.Private}`]: {
    background: theme.palette.notesLabel.private
  },
  [`${TimeSignalClassification.Accepted}`]: {
    background: theme.palette.notesLabel.accepted
  }
}));

type NoteClassificationTagProps = {
  noteClassification: TimeSignalClassification;
  className?: string;
  classes?: ClassNameMap;
};

export const NoteClassificationTag: React.FC<NoteClassificationTagProps> = ({
  noteClassification,
  className,
  classes: overrideCls
}: NoteClassificationTagProps) => {
  const classes = useStyles({ classes: overrideCls });
  const { formatMessage } = useIntl();
  const classificationValue = formatMessage({
    id: `notes.${noteClassification.toLowerCase()}`
  });
  return (
    <div
      data-testid={`note-tag-${noteClassification}`}
      className={classnames(classes.root, className)}
    >
      <Typography
        className={classnames(classes.label, classes[`${noteClassification}`])}
        variant="caption"
      >
        {classificationValue}
      </Typography>
    </div>
  );
};
